module.exports = __webpack_public_path__ + "../front/img/368bøjestang+hylde.6b6cd656.svg";